import { h, Component } from 'preact';
import { route } from 'preact-router';
import { MkComponent } from 'lib/mkjs/mkcomponent';
import ContactEntity from "entities/contactentity";
import ContactIdentityVerification from "entities/contactidentityverfication";
import { getIdentity, getVerification } from "entities/contactinfo";
import { Loading } from 'lib/mkjs';

export default class ContactIdentity extends MkComponent {
	getBasePath() {
		return "/contact-identities"
	}

	getFieldComponent(fieldName) {
		const fieldComponents = {
			entity: this._fieldReference(ContactEntity)
		}
		return fieldComponents[fieldName];
	}

	userCan(action) {
		return this.props.userIsAdmin || action == 'create';
	}
}

class NewIdentityVerification extends ContactIdentityVerification {
	getName() {
		return 'contactIdentityVerification';
	}

	getCreateFields() {
		return {}
	}

	getEditTitle(isUpdate, entity) {
		return '';
	}

	renderCreate() {
		//TODO validate identifier and type being passed via path
		return <div>
			<h1>Verify My Identity</h1>
			<p class="m-2">Click <b>Send Now</b> and we will send a verification message to</p>
			<div class="m-3">{this.props.identifier}</div>
			<p class="m-2"> Once you verify this address,
			your connections will see that this address belongs to you. Other Addy members will also be able
			to send you a connection request if they have this address in their address book.</p>
			{super.renderCreate()}
		</div>
		//TODO success message: Verification sent! Enter your verification code below or click on the link in the email to get verified!
		//for on linked page: Almost done! click "verify" to complete the process (created ContactIdentity from the verification)
	}

	getEditButtonText(isUpdate) {
		return isUpdate ? 'Update' : 'Send Now!';
	}

	prepareCreate(subject) {
		return {
			type: this.props.type,
			identifier: this.props.identifier,
			entity: {
				id: this.props.contactEntity.id
			}
		}
	}

	getViewUrl(item) {
		return getVerifyIdentityUrl(item.type,item.identifier);
	}
}

class VerifiedIdentity extends ContactIdentityVerification {
	getName() {
		return 'contactIdentityVerification';
	}

	getDisplayName() {
		return 'Your Verified Identity';
	}

	getFields(entity) {
		const fields = super.getFields(entity);
		return {
			type: fields.type,
			identifier: fields.identifier
		}
	}

	renderView(subject) {
		return <div>
			{super.renderView(subject)}
			<p>
				People who have this email address in their addy will be able to send you a connection request.
			</p>
			<button class="btn btn-mkjs-primary" onClick={()=>{
				if (window.confirm("Are you sure you want to permanently delete this verification?")) {
					this.submitDelete(subject.verification);
				}
			}}>Remove from account</button>
		</div>
	}
	//TODO include ability to delete, but do not allow editing
}

class PendingIdentityVerification extends ContactIdentity {
	getName() {
		return 'contactIdentity';
	}

	getCreateFields() {
		return {
			verificationCode: {
				type: "string",
				default: this.props.code,
				placeholder: ""
			}
		}
	}

	getEditTitle(isUpdate, entity) {
		return '';
	}

	getEditButtonText(isUpdate) {
		return isUpdate ? 'Update' : 'Verify!';
	}

	renderCreate() {
		//TODO show type, identifier, datetime requested (message sent at ...) and code field
		//TODO resend code
		return <div>
			<h1>Confirm My Identity</h1>
			<p class="m-2">We sent a confirmation message to</p>
			<div class="m-3">{this.props.identifier}</div>
			<p class="m-2">
				To confirm this identity, click on the link in the message we sent,
				or paste the confirmation code into the box below.
			</p>
			{super.renderCreate()}
		</div>
	}

	prepareCreate(subject) {
		const entity = this.props.contactEntity;
		const verification = getVerification(this.props.type, this.props.identifier, entity);
		return {
			type: this.props.type,
			identifier: this.props.identifier,
			entity: {
				id: entity.id
			},
			verification: {
				id: verification.id,
				verificationCode: subject.verificationCode
			}
		}
	}

	getViewUrl(item) {
		return getVerifyIdentityUrl(item.type,item.identifier);
	}
}

export class MyIdentity extends Component {
	render() {
		const entity = this.props.contactEntity;
		if (!entity) {
				return <Loading />
		}

		const confirmed = getIdentity(this.props.type, this.props.identifier, entity);
		const confirmationInProcess = getVerification(this.props.type, this.props.identifier, entity);

		if (confirmed) {
			return <VerifiedIdentity {...this.props} onDelete={()=>{this.props.loadCurrentUser(); route('/me')}} subject={confirmed}/>
		} else if (confirmationInProcess) {
			return <PendingIdentityVerification {...this.props} onCreate={this.props.loadCurrentUser} creating />
		} else {
			return <NewIdentityVerification {...this.props} onCreate={this.props.loadCurrentUser} creating />
		}
	}
}



// WEBPACK FOOTER //
// ./entities/contactidentity/index.js